import React from 'react';
import PropTypes from 'prop-types';

import invert from 'lodash/invert';
import { registerField } from 'core/forms';

import { Checkbox } from 'uikit/inputs';

import styles from '../styles/formFieldTextBoolean.module.scss';

const FormFieldTextBoolean = ({
  fieldId,
  schema = { isDisabled: false, labelText: '', options: {} },
  updateField,
  value = false,
}) => {
  const onChange = (checkboxValue) => {
    const updatedValue = invert(schema.options)[checkboxValue];
    updateField(updatedValue);
  };

  let inputFieldId = fieldId;

  if (schema.labelText) {
    inputFieldId = `${fieldId}-input`;
  }

  const checked = schema.options[value];

  return (
    <Checkbox
      id={inputFieldId}
      name="checkbox"
      value={checked}
      label={schema.labelText}
      isDisabled={schema.isDisabled}
      className={styles.element}
      onChange={onChange}
    />
  );
};

FormFieldTextBoolean.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    labelText: PropTypes.string,
    isDisabled: PropTypes.bool,
    // options should be an object, whose keys are the text values and values are the boolean values
    options: PropTypes.shape({}),
  }),
};

registerField('TextBoolean', React.memo(FormFieldTextBoolean));

export default FormFieldTextBoolean;
